import getSimpleDateString from './getSimpleDateString';
export default function dateAIsGreaterThanOrEqualToB(a, b) {
    if (!a || !b)
        return false;
    const res = getSimpleDateString(a) >= getSimpleDateString(b);
    return res;
}
